import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import Loader from "react-spinner-loader";
import { useAsyncDebounce } from "react-table";
import * as Yup from "yup";
import {
  Button,
  Card,
  CardBody,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  Table,
  UncontrolledDropdown,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
} from "reactstrap";
import { decryptedValue, isPermission, uId } from "common/utility";
import ToastDialog from "components/Common/ToastDialog";
import { addPoc, deletePoc, editPoc, getPoc, getPrimaryPoc, setPrimaryPoc, getAnchorPoc, addCounterpartyPoc, getCounterparties } from "http/fundLync/poc.helper";
import { formatDateString, formatDateString1 } from "./borrowingProfile";
import CommonDialog from "components/Common/CommonDialog";
import { getDropDownList } from "http/fundLync/dropdown.helper";

const PointOfContact = ({entityType,isOpen,onAccordionToggle}) => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [isAddPOCOpen, setAddPOCOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [loader, setLoader] = useState(false);
  const [pocList, setPocList] = useState([]);
  const urlParams = new URLSearchParams(window.location.search);
  // const encodedId = urlParams.get("id");
  // const entityId = atob(encodedId);
  const [pocData, setPoc] = useState(null);
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [isNewDataPermission, setNewDataPermission] = useState(false);
  const [isEditPocPermission, setEditPocPermission] = useState(false);
  const [pocSelectedGroup, setPocSelectedGroup] = useState(null);
  const [selectedViewPoc, setSelectedViewPoc] = useState(null);
  const [isViewOpen, setViewOpen] = useState(false);
  const [entityId, setEntityId] = useState('')
  const [encodedId, setEncodedId] = useState('')
  const [anchorPocList, setAnchorPocList] = useState([]);
  const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAddCounterpartyPOCOpen, setIsAddCounterpartyPOCOpen] = useState(false);
  const [selectedMulti, setSelectedMulti] = useState([]);
  const [counterpartyList, setCounterpartyList] = useState([]);
  const currentDate = new Date().toISOString().split("T")[0];
  const [isRedirectPermission, setIsRedirectPermission] = useState(false);
  const [regionList, setReigonList] = useState([]);
  useEffect(()=>{
    const userDetails = decryptedValue(localStorage.getItem("user"));
      if(userDetails.entityType === "Partner" || userDetails.entityType === "Owner"){
        setEncodedId(urlParams.get("id"))
        setEntityId(atob(encodedId))
      }else{
        setEncodedId(entityId)
        setEntityId(userDetails.entityId)
      }
  },[ entityId, encodedId])
  // validation
  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      firstname: (pocData && pocData[0].firstname) || "",
      lastname: (pocData && pocData[0].lastname) || "",
      email: (pocData && pocData[0].email) || "",
      contactNumber: (pocData && pocData[0].contactNumber) || "",
      designation: (pocData && pocData[0].designation) || "",
      dateOfBirth: (pocData && pocData[0].dateOfBirth) || "",
      id: (pocData && pocData[0].id) || "",
      region:(pocData && pocData[0].region) || "",
      branch:(pocData && pocData[0].branch) || "",
    },
    validationSchema: Yup.object({
      firstname: Yup.string().required("First name is Required"),
      lastname: Yup.string().required("Last Name is Required"),
      contactNumber: Yup.string().required("Mobile number is Required")
          .matches(/^[1-9][0-9]*$/, "Mobile number must not start with zero and should contain only digits")
          .min(10, "Mobile number must be at least 10 digits")
          .max(10, "Mobile number must be at most 10 digits"),
      email: Yup.string().required("Email is Required").email("Invalid email address"),
      designation: Yup.string(),
      dateOfBirth: Yup.string().required(
        "Please Enter Date of Birth"
      ),
      region: Yup.string(),
      branch: Yup.string(),
    }),
    onSubmit: (values) => {
      if (isEdit) {
        const data = {
          id: values.id,
          firstname: values.firstname,
          lastname: values.lastname,
          email: values.email,
          contactNumber: values.contactNumber,
          designation: values.designation,
          dateOfBirth: values.dateOfBirth,
          entityId:pocList[0]?.entityId,
          region: values.region,
          branch: values.branch,
        }; 
        editPoc(data)
          .then((response) => {
            if (response.code == 201 && response.status) {
              setToastInfo({
                message: "Point of Contact updated",
                showToast: true,
                role: "success",
              })
              callPocAfterSave();
              setAddPOCOpen(false);
            } else {
              const { message } = response;
              setToastInfo({
                message: message,
                showToast: true,
                role: "error",
              });
            }
          })
          .catch((err) => {
            console.log(err)
          })
      } else {
        let data = {}
        if(pocList.length == 0){
          
           data = {
            firstname: values.firstname,
            lastname: values.lastname,
            email: values.email,
            contactNumber: values.contactNumber,
            designation: values.designation,
            dateOfBirth: values.dateOfBirth,
            isPrimary: true,
            entityId:entityId,
            region: values.region,
            branch: values.branch,
  
        };
        }else{
          data = {
            firstname: values.firstname,
            lastname: values.lastname,
            email: values.email,
            contactNumber: values.contactNumber,
            designation: values.designation,
            dateOfBirth: values.dateOfBirth,
            entityId:entityId,
            region: values.region,
            branch: values.branch,
        };
        }
        addPoc(data)
          .then((response) => {
            if (response.code == 201 && response.status) {
              setToastInfo({
                message: "Entity Contact Details Saved",
                showToast: true,
                role: "success",
              });
              if(pocList.length === 0){
                setTimeout(() => {
                  window.location.reload();
                }, 1000)
              }
              callPocAfterSave();
              setAddPOCOpen(false);
            } else {
              const { message } = response;
              setToastInfo({
                message: message,
                showToast: true,
                role: "error",
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }

      validation.resetForm();
    },
  });

  useEffect(() => {
    if(isOpen){
    getPoc({ entityId })
      .then((response) => {
        if (response.status) {
            setPocList(response?.data?.data);
        }
        else{
            setPocList([]);
        }
      })
      .catch((error) => {
        console.error(error);
      });
    }
    checkPermissions();
  }, [isOpen,entityId]);

  const checkPermissions = async () => {
    const isAddpermission = await isPermission("address", "create_permission");
    const editAddressPermission = await isPermission("address", "edit_permission");
    const isPerm = await isPermission("entity_detail", "full_access");
    setIsRedirectPermission(isPerm);
    setNewDataPermission(isAddpermission);
    setEditPocPermission(editAddressPermission);
  };

  const handleCustomerClicks = () => {
    setAddPOCOpen(true);
    setIsEdit(false);
    setPoc(null);
  };

  const handleCancelrClicks = () => {
    validation.resetForm();
    setAddPOCOpen(false);
    setPoc(null);
  };

  const EditPocDetails = (id) => {
    setIsEdit(true);
    const filteredData = pocList.filter((elem) => {
      return elem.id == id;
    });

    setPoc(filteredData);
    let val = {label: filteredData[0]?.bankName, value: filteredData[0]?.bankName}
    setPocSelectedGroup(val);
    setAddPOCOpen(true);
  };
  
  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
    setAddPOCOpen(false);
    setIsEdit(false);
    if (onAccordionToggle) {
      onAccordionToggle(!isDropdownOpen);
    }
  };

  const callSetAsPrimary = (id, entityId) => {
    setPrimaryPoc({ id, entityId })
      .then((response) => {
        if(response.status){
            setToastInfo({
                message: response.message,
                showToast: true,
                role: "success",
              });
              setTimeout(() => {
                window.location.reload();
              }, 1000);
        }else{
            setToastInfo({
                message: "Something Went Wrong",
                showToast: true,
                role: "error",
            });
        }
      })
      .catch((error) => {
        setToastInfo({
            message: "Something Went Wrong",
            showToast: true,
            role: "error",
        });
      });
  };

  const callPocAfterSave = () => {
    getPoc({ entityId })
      .then((response) => {
        if (response.status) {
          setPocList(response?.data?.data);
      }
      else{
          setPocList([]);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
      }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
  };

  const ViewAddress = (id) => {
    const selectedBank = pocList.find((elem) => elem.id == id);
    setSelectedViewPoc(selectedBank);
    setViewOpen(true);
  };

  const deleteDetail = (id) => {
    const message = 'Are you sure you want to delete this data?'
    const data = {id}
    setShowCommonDialog({ isShow: true, message, data })
  };

  const dialogActionAccept = (action, data) => {
    if (action == 1) {
        setShowCommonDialog({ isShow: false })
        deletePoc({id : data.id})
        .then((response) => {
          if (response.code == 201 && response.status) {
            setToastInfo({
              message: "Entity Contact Deleted Succesfully",
              showToast: true,
              role: "success",
            });
            callPocAfterSave();
          } else {
            const { message } = response;
            setToastInfo({
              message: message,
              showToast: true,
              role: "error",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
        setShowCommonDialog({ isShow: false })
    }
  }
  
  const viewAssociatedCounterparties = (id) => {
    getAnchorContactsList(entityId, id)
    setIsModalOpen(true)
    validation2.setFieldValue('contactId', id)
  };

  const getAnchorContactsList = (anchorId,id) => {
    getAnchorPoc({ entityId: anchorId, isAnchor: true, contactId: id })
      .then((response) => {
        if (response.status && response?.data?.length > 0) {
          setAnchorPocList(response?.data);
        }
        else {
          setAnchorPocList([]);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  const validation2 = useFormik({
    enableReinitialize: true,
    initialValues: {
      counterpartyId: "",
      contactId: "",
    },
    validationSchema: Yup.object({
      counterpartyId: Yup.string().required("Please select counterparty"),
    }),
    onSubmit: (values) => {
      const data = {
        anchorId: entityId,
        contactId: values.contactId
      };
      data.counterpartyId = values.counterpartyId.split(',')

      addCounterpartyPoc(data)
        .then((response) => {
          if (response.code == 201 && response.status) {
            setToastInfo({
              message: "Contact Details Saved",
              showToast: true,
              role: "success",
            });
            getAnchorContactsList(entityId, data.contactId)
            validation2.resetForm();
            setIsAddCounterpartyPOCOpen(false);
            setSelectedMulti('')
            setIsModalOpen(false)
          } else {
            const { message } = response;
            setToastInfo({
              message: message,
              showToast: true,
              role: "error",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  });

  const handleMulti1 = (selectedOptions) => {
    const newData = [];
    selectedOptions.forEach((ele) => {
      newData.push(ele.value);
    });
    validation2.setFieldValue('counterpartyId', newData.join(","))
    setSelectedMulti(selectedOptions);
  };

  const handleCancelClicks = () => {
    validation2.resetForm();
    setIsAddCounterpartyPOCOpen(false);
    setSelectedMulti('')
  };

  const getCounterpartyList = (entityId) => {
    getCounterparties({ entityId })
      .then((response) => {
        if (response.status && response?.data?.length > 0) {
          setCounterpartyList(response?.data);
        }
        else {
          setCounterpartyList([]);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  const handleMouseEnter = (event) => {
    event.target.style.color = "#34c38f";
    event.target.style.textDecoration = "underline";
  };

  const handleMouseLeave = (event) => {
    event.target.style.color = "#21aa47";
    event.target.style.textDecoration = "none";
  };

  const navigateToEditEntity = (entityId) => {
    const user = decryptedValue(localStorage.getItem("user"));
    if (entityId) {
      const encryptedId = btoa(entityId.toString());
      const url = `/${user.roleName}/entity-Dashboard?id=${encodeURIComponent(encryptedId)}`;
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };
useEffect(()=>{
  const loadRegionData = async () => {
    try {
      // Fetch region dropdown values
      const regionResponse = await getDropDownList({ dropdownName: "region" });
  
      const regionValues = regionResponse.data?.rows?.find(
        (dv) => dv.dropdownName === "region"
      )?.dropdownValues || [];
  
      // Set the region values in state
      setReigonList(regionValues);
    } catch (error) {
      console.error("Error fetching region data:", error);
    }
  };
  loadRegionData();
  checkPermissions();
},[])
  
  
  return (
    <React.Fragment>
      <Row lg="12">
        <div>
          <Card style={{ padding: "10px" }}>
            <div
              className="d-flex justify-content-between mt-1"
              style={{ cursor: "pointer" }}
              onClick={toggleDropdown}
            >
              <div>
                <h5>Entity Contacts</h5>
              </div>
              <div className="me-2">
                <i
                  className={`fas fa-angle-${isDropdownOpen ? "up" : "down"}`}
                  style={{ fontSize: "20px" }}
                ></i>
              </div>
            </div>
            {isViewOpen && selectedViewPoc && (
              <div>
                <div className="text-sm-end">
                    <Button
                      type="button"
                      color="outline-success"
                      className="btn-rounded mb-2 me-2"
                      onClick={() => setViewOpen(false)}
                    >
                      close
                    </Button>
                </div>
              <Row className="mb-3">
                <Col sm="6" md="4" lg="4" className="mb-3 mt-2">
                  <Label className="d-block entityDetails">Contact Name</Label>
                  {`${selectedViewPoc.firstname || ''} ${selectedViewPoc.lastname || ''}`.trim()}
                </Col>
                <Col sm="6" md="4" lg="4" className="mb-3 mt-2">
                  <Label className="d-block entityDetails">Email</Label>
                  <span className="mb-0 entityDetailsValue">{selectedViewPoc.email}</span>
                </Col>
                <Col sm="6" md="4" lg="4" className="mb-3 mt-2">
                  <Label className="d-block entityDetails">Contact number</Label>
                  <span className="mb-0 entityDetailsValue">{selectedViewPoc.contactNumber}</span>
                </Col>
                <Col sm="6" md="4" lg="4" className="mb-3 mt-2">
                  <Label className="d-block entityDetails">Designation</Label>
                  <span className="mb-0 entityDetailsValue">{selectedViewPoc.designation}</span>
                </Col>
                <Col sm="6" md="4" lg="4" className="mb-3 mt-2">
                  <Label className="d-block entityDetails">Date of Birth</Label>
                  <span className="mb-0 entityDetailsValue">{formatDateString(selectedViewPoc.dateOfBirth)}</span>
                </Col>
                <Col sm="6" md="4" lg="4" className="mb-3 mt-2">
                  <Label className="d-block entityDetails">Region</Label>
                  <span className="mb-0 entityDetailsValue">{selectedViewPoc.region}</span>
                </Col>
                <Col sm="6" md="4" lg="4" className="mb-3 mt-2">
                  <Label className="d-block entityDetails">Branch</Label>
                  <span className="mb-0 entityDetailsValue">{selectedViewPoc.branch}</span>
                </Col>
              </Row>
              </div>
            )}
            {isAddPOCOpen && (
              <div>
                <div>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      handleSubmit(e)
                      return false;
                    }}
                  >
                    <Row className="mb-3">

                      <Col sm="12" md="6">
                        <Label className="required-sign form-label mt-4" >First Name <i className="mdi mdi-asterisk"></i></Label>
                        <Input
                          name="firstname"
                          type="text"
                          placeholder="Enter first name"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.firstname || ""}
                          invalid={
                            validation.touched.firstname &&
                              validation.errors.firstname
                              ? true
                              : false
                          }
                        />
                        {validation.touched.firstname &&
                          validation.errors.firstname ? (
                          <FormFeedback type="invalid">
                            {validation.errors.firstname}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col sm="12" md="6">
                        <Label className="required-sign form-label mt-4" >Last Name <i className="mdi mdi-asterisk"></i></Label>
                        <Input
                          name="lastname"
                          type="text"
                          placeholder="Enter last name"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.lastname || ""}
                          invalid={
                            validation.touched.lastname &&
                              validation.errors.lastname
                              ? true
                              : false
                          }
                        />
                        {validation.touched.lastname &&
                          validation.errors.lastname ? (
                          <FormFeedback type="invalid">
                            {validation.errors.lastname}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      
                      <Col sm="12" md="6">
                        <Label className="required-sign form-label mt-4" >Email <i className="mdi mdi-asterisk"></i></Label>
                        <Input
                          name="email"
                          type="text"
                          placeholder="Enter Email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email &&
                              validation.errors.email
                              ? true
                              : false
                          }
                        />
                        {validation.touched.email &&
                          validation.errors.email ? (
                          <FormFeedback type="invalid">
                            {validation.errors.email}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col sm="12" md="6">
                        <Label className="required-sign form-label mt-4">contact number <i className="mdi mdi-asterisk"></i></Label>
                        <Input
                          name="contactNumber"
                          type="text"
                          placeholder="Enter mobile number"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.contactNumber || ""}
                          invalid={
                            validation.touched.contactNumber &&
                              validation.errors.contactNumber
                              ? true
                              : false
                          }
                        />
                        {validation.touched.contactNumber &&
                          validation.errors.contactNumber ? (
                          <FormFeedback type="invalid">
                            {validation.errors.contactNumber}
                          </FormFeedback>
                        ) : null}
                      </Col>


                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">Designation</Label>
                        <Input
                          name="designation"
                          type="text"
                          placeholder="Enter designation"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.designation || ""}
                          invalid={
                            validation.touched.designation &&
                              validation.errors.designation
                              ? true
                              : false
                          }
                        />
                        {validation.touched.designation &&
                          validation.errors.designation ? (
                          <FormFeedback type="invalid">
                            {validation.errors.designation}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col sm="12" md="6">
                        <Label className="required-sign form-label mt-4">
                          Date of Birth <i className="mdi mdi-asterisk"></i>
                        </Label>
                        <Input
                          name="dateOfBirth"
                          type="date"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={formatDateString1(validation.values.dateOfBirth) || ""}
                          invalid={
                            validation.touched.dateOfBirth &&
                            validation.errors.dateOfBirth
                          }
                          max={currentDate}
                        />
                        {validation.touched.dateOfBirth &&
                          validation.errors.dateOfBirth ? (
                          <FormFeedback type="invalid">
                            {validation.errors.dateOfBirth}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col sm="12" md="6">
                      <Label className="form-label mt-4">
                        Select Region 
                      </Label>
                      <Input
                        name="region"
                        type="select"
                        onChange={(e) => {
                          validation.handleChange(e);
                        }}
                        onBlur={validation.handleBlur}
                        value={validation.values.region || ""}
                        invalid={
                          validation.touched.region &&
                          validation.errors.region
                        }
                      >
                        <option value="" disabled>
                          Select Region
                        </option>
                        {regionList.map((option) => (
                          <option key={uId()} value={option.dropdownValue}>
                            {option.displayName}
                          </option>
                        ))}
                      </Input>
                      {validation.touched.region &&
                        validation.errors.region ? (
                        <FormFeedback type="invalid">
                          {validation.errors.region}
                        </FormFeedback>
                      ) : null}
                    </Col>

                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">Branch</Label>
                        <Input
                          name="branch"
                          type="text"
                          placeholder="Enter branch"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.branch || ""}
                          invalid={
                            validation.touched.branch &&
                              validation.errors.branch
                              ? true
                              : false
                          }
                        />
                        {validation.touched.branch &&
                          validation.errors.branch ? (
                          <FormFeedback type="invalid">
                            {validation.errors.branch}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col>
                        <div className="text-end">
                          <button
                            type="button"
                            className="btn btn-outline-secondary save-customer me-2"
                            onClick={handleCancelrClicks}
                          >
                            Cancel
                          </button>
                          {isEdit ? (
                            <button
                            type="submit"
                            className="btn btn-success save-customer"
                          >
                            Update
                          </button>
                          ): (
                            <button
                            type="submit"
                            className="btn btn-success save-customer"
                          >
                            Save
                          </button>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </div>
            )}
            {isDropdownOpen && (
              <Row>
                <div className="text-sm-end">
                  {isNewDataPermission && (
                    <Button
                      type="button"
                      color="success"
                      className="btn-rounded mb-2 me-2"
                      onClick={handleCustomerClicks}
                    >
                      <i className="mdi mdi-plus me-1" />
                      New Entity Contact
                    </Button>
                  )}
                </div>
                <Col xs="12" className="mt-1 mb-2">
                  <div className="table-responsive">
                    <Table className="table table-bordered table-striped mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>Id</th>
                          <th>Contact Name</th>
                          <th>Email</th>
                          <th>Contact number</th>
                          <th>Designation</th>
                          <th>Region</th>
                          <th>Branch</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {pocList?.length == 0 ? (
                          <tr>
                            <td colSpan={8} className="text-center">
                              No data found
                            </td>
                          </tr>
                        ) : (
                            pocList?.map((elem, index) => (
                            <tr key={uId()}>
                              <td>{index + 1}</td>
                                <td>
                                  {`${elem.firstname || ''} ${elem.lastname || ''}`.trim()}
                                </td>
                              <td>{elem.email}</td>
                              <td>{elem.contactNumber}</td>
                              <td>{elem.designation}</td>
                              <td>{elem.region}</td>
                              <td>{elem.branch}</td>
                              <td>
                                <UncontrolledDropdown>
                                  <DropdownToggle
                                    tag="a"
                                    className="card-drop"
                                  >
                                    <i className="mdi mdi-dots-horizontal font-size-18"></i>
                                  </DropdownToggle>

                                  {isEditPocPermission && <DropdownMenu className="dropdown-menu-end">
                                    <DropdownItem
                                        onClick={() => {
                                            callSetAsPrimary(elem.id, elem.entityId);
                                        }}
                                        >
                                        <i
                                        className="mdi mdi-account-check font-size-16 text-success me-1"
                                        id="primarytooltip"
                                        ></i>
                                        Set As Primary
                                        <UncontrolledTooltip
                                            placement="top"
                                            target="primarytooltip"
                                        >
                                        Set As Primary 
                                        </UncontrolledTooltip>
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() => {
                                        EditPocDetails(elem.id);
                                      }}
                                    >
                                      <i
                                        className="mdi mdi-pencil font-size-16 text-success me-1"
                                        id="edittooltip"
                                      ></i>
                                      Edit
                                      <UncontrolledTooltip
                                        placement="top"
                                        target="edittooltip"
                                      >
                                        Edit
                                      </UncontrolledTooltip>
                                    </DropdownItem>
                                    <DropdownItem
                                        onClick={() => {
                                            ViewAddress(elem.id);
                                        }}
                                        >
                                        <i
                                        className="mdi mdi-eye font-size-16 text-success me-1"
                                        id="viewtooltip"
                                        ></i>
                                        View
                                        <UncontrolledTooltip
                                            placement="top"
                                            target="viewtooltip"
                                        >
                                        View
                                        </UncontrolledTooltip>
                                    </DropdownItem>
                                    <DropdownItem
                                        onClick={() => {
                                            deleteDetail(elem.id);
                                        }}
                                        >
                                        <i
                                        className="mdi mdi-delete font-size-16 text-success me-1"
                                        id="deletetooltip"
                                        ></i>
                                        Delete
                                        <UncontrolledTooltip
                                            placement="top"
                                            target="deletetooltip"
                                        >
                                        Delete
                                        </UncontrolledTooltip>
                                    </DropdownItem>
                                     {entityType == 'Anchor' && ( <DropdownItem
                                        onClick={() => {
                                          viewAssociatedCounterparties(elem.id);
                                        }}
                                      >
                                        <i
                                          className="mdi mdi-eye font-size-16 text-success me-1"
                                          id="viewtooltip"
                                        ></i>
                                        Associated counterparties
                                        <UncontrolledTooltip
                                          placement="top"
                                          target="viewtooltip"
                                        >
                                          Associated counterparties
                                        </UncontrolledTooltip>
                                      </DropdownItem>)}
                                  </DropdownMenu>}
                                </UncontrolledDropdown>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </Table>
                  </div>
                </Col>
              </Row>
            )}
          </Card>
        </div>
      </Row>
      <Modal
        isOpen={isModalOpen}
        role="dialog"
        autoFocus={true}
        centered
        data-toggle="modal"
        toggle={() => {
          handleCancelClicks()
          setIsModalOpen(!isModalOpen);
        }}
      >
        <div>
          <ModalHeader
            className="border-bottom-0"
            toggle={() => {
              handleCancelClicks()
              setIsModalOpen(!isModalOpen);
            }}
          ></ModalHeader>
        </div>
        <div className="modal-body">
          {anchorPocList.length > 0 && (
            <div>
              <div className="financier-header mb-2">Associated counterparties</div>
              {(() => {
                let numberOfColumns = 1;

                const columnSize = Math.ceil(anchorPocList.length / numberOfColumns);
                const columns = Array.from({ length: numberOfColumns }, (_, index) =>
                  anchorPocList.slice(index * columnSize, (index + 1) * columnSize)
                );

                return (
                  <Table className="table table-bordered table-striped mb-0">
                    <tbody>
                      <tr>
                        {columns.map((column, index) => (
                          <td key={index}>
                            <ul className="financier-list">
                              {column.map((ele) => (
                                <li key={uId()}>
                                  {isRedirectPermission && (<td title={ele.Counterpartyame} style={{ width: '250px' }}>
                                    <a
                                      href="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        navigateToEditEntity(ele.counterpartyId);
                                      }}
                                      onMouseEnter={handleMouseEnter}
                                      onMouseLeave={handleMouseLeave}
                                      style={{
                                        cursor: "pointer",
                                        color: "#21aa47",
                                        width: "170px",
                                        textDecoration: "none",
                                      }}
                                      title={ele.Counterpartyame || ""}
                                    >
                                      <span> {ele.Counterpartyame || ""}</span>
                                    </a>
                                  </td>)}
                                  {!isRedirectPermission && (<td title={ele.Counterpartyame} style={{ width: '250px' }}>
                                    {ele.Counterpartyame || ""}
                                  </td>)}
                                </li>
                              ))}
                            </ul>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </Table>
                );
              })()}
            </div>
          )}
          {anchorPocList.length === 0 && (
            <div className="text-success font-size-14 text-center mt-4 mb-4">
              No associated counterparties found
            </div>
          )}
          {isAddCounterpartyPOCOpen && (
            <div>
              <div>
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation2.handleSubmit();
                    handleSubmit(e)
                    return false;
                  }}
                >
                  <Row className="mb-3">
                    <Col sm="12" md="12">
                      <Label className="form-label grey mt-2">
                        Counterparty Name*
                      </Label>
                      <Select
                        name="counterpartyId"
                        value={selectedMulti}
                        isMulti={true}
                        onChange={handleMulti1}
                        options={counterpartyList?.map((option, index) => ({
                          label: option.Counterpartyame,
                          value: option.counterpartyId,
                        }))}
                        onBlur={validation2.handleBlur}
                        className={`select-dropdown ${validation2.touched.counterpartyId &&
                          validation2.errors.counterpartyId
                          ? "is-invalid"
                          : ""
                          }`}
                      />
                      {validation2.touched.counterpartyId &&
                        validation2.values.counterpartyId == "" && (
                          <p
                            style={{
                              color: "rgb(245,116,116)",
                              fontSize: "11px",
                            }}
                          >
                            {validation2.errors.counterpartyId}
                          </p>
                        )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col>
                      <div className="text-end">
                        <button
                          type="button"
                          className="btn btn-outline-secondary save-customer me-2"
                        onClick={handleCancelClicks}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn btn-success save-customer"
                        >
                          Save
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </div>
          )}
          {!isAddCounterpartyPOCOpen && (<div className="text-success font-size-14 mt-4 mb-4">
            <Button
              type="button"
              color="success"
              className="btn-rounded mb-2 me-2"
              onClick={() => {
                let data = anchorPocList?.map((option, index) => ({
                  label: option.Counterpartyame,
                  value: option.counterpartyId,
                }))
                setSelectedMulti(data)
                setIsAddCounterpartyPOCOpen(!isAddCounterpartyPOCOpen)
                getCounterpartyList(entityId)
                const newData = [];
                data.forEach((ele) => {
                  newData.push(ele.value);
                });
                validation2.setFieldValue('counterpartyId', newData.join(","))
              }}
            >
              <i className="mdi mdi-plus me-1" />
              Associate counterparties
            </Button>
          </div>)}
        </div>
      </Modal>
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
      <Loader show={loader} type="box" message="Fetching Data" />
      {
        showCommonDialog &&
        <CommonDialog
          isShow={showCommonDialog.isShow}
          message={showCommonDialog.message} data={showCommonDialog.data}
          postitiveBtn={'Yes'} negativeBtn={'No'} onCloseFn={dialogActionAccept}
        />
      }
    </React.Fragment>
  );
};

export default PointOfContact;
